module.exports = __webpack_public_path__ + "static/img/C4D0007.b342c11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0007.jpg
// module id = HSSl
// module chunks = 0